module.exports = __webpack_public_path__ + "static/media/749ced26-ccf0-47f8-b24f-ba6332156f22.61dd7bf9.webp";